import { BetStatus, EventPeriod, MarketType } from '@/constants';
import { AppError } from '@/errors/appError';
import { betStatusDictionary } from '@/stores';
import { useAppStore } from '@/stores/app';
import { BetItem } from '@/models/bet';

//todo need to refactor and remove this function
export function betTypeIdToMarketTypeId(id: number): MarketType {
    if (id === 1) return MarketType.Handicap;
    if (id === 2) return MarketType.Goal;
    if (id === 3) return MarketType.OneXTwo;
    if (id === 4) return MarketType.Bts;
    if (id === 5) return MarketType.Dc;
    if (id === 6) return MarketType.Cs;
    if (id === 7) return MarketType.CornersHandicap;
    if (id === 8) return MarketType.CornersGoal;

    throw new AppError(`${id} is not a valid MarketTypeId`);
}

export function calculatePosition(customEventId: string, periodTypeId: EventPeriod | null, getEventScoreForBet: (bet: BetItem) => { home: number | null; away: number | null }): number | null {
    const appStore = useAppStore();
    let bets;

    if (periodTypeId !== null) {
        bets = appStore.getBetsByParams({ customEventId: customEventId, periodTypeId: periodTypeId });
    } else {
        bets = appStore.getBetsByParams({ customEventId: customEventId });
    }

    let calculatedBetsCount = 0,
        totalBetBalance = 0;

    bets.forEach((bet) => {
        if (bet.statusId === BetStatus.Rejected || bet.statusId === BetStatus.Abnormal || bet.statusId === BetStatus.Void || bet.statusId === BetStatus.Refunded) {
            console.log(`Bet #${bet.id} position calculation is skipped due to status ${betStatusDictionary.nameById(bet.statusId)}`);
            return;
        }

        const eventCurrentScore = getEventScoreForBet(bet);

        //possible situation when for LIVE game score not confirmed
        if (eventCurrentScore.home === null || eventCurrentScore.away === null) {
            return;
        }

        calculatedBetsCount++;

        const result = bet.calculateExpectedResult(eventCurrentScore.home, eventCurrentScore.away);

        if (result === null) {
            return;
        }

        totalBetBalance += Number(result.balance);
    });

    return calculatedBetsCount > 0 ? totalBetBalance : null;
}
